import { Divider, Table, Spin, Select, Space } from 'antd'
import { useEffect, useState } from 'react'
import { getTreasureHunter, getTopUser } from 'src/api/treasurehunter'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { fetchCountryProvider } from 'src/api/authen'

const TreasureHunterLeaderBoard = () => {
  const [loading, setLoading] = useState(true)
  const [treasureHunter, setTreasureHunter] = useState('')
  const [transformedData, setTransformedData] = useState([])
  const [country, setCountry] = useState('')
  const [countries, setCountries] = useState([])
  const [treasureHunters, setTreasureHunters] = useState([])
  const rewardOrder = ['DIAMOND', 'CIRCLE', 'STAR']

  const fetchCountry = async () => {
    try {
      const data = await fetchCountryProvider()
      const countryOptions = data.data.map((item) => ({
        label: item.countryName,
        value: item.countryCode,
      }))
      setCountries(countryOptions)

      if (countryOptions.length > 0) {
        setCountry(countryOptions[0].value)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const fetchTreasureHunter = async () => {
    try {
      const data = await getTreasureHunter(0, 100)
      const treasureHunterOptions = data.data.map((item) => ({
        label: item.name,
        value: item.id,
      }))
      setTreasureHunters(treasureHunterOptions)

      if (treasureHunterOptions.length > 0) {
        setTreasureHunter(treasureHunterOptions[0].value)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleCountryChange = (value) => {
    setCountry(value)
  }

  const handleTreasureHunterChange = (value) => {
    setTreasureHunter(value)
  }

  const fetchTopScoresData = async (id, country) => {
    try {
      setLoading(true)
      const response = await getTopUser(id, country)
      const transformedData = response.data
      setTransformedData(transformedData)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCountry()
    fetchTreasureHunter()
  }, [])

  useEffect(() => {
    if (treasureHunter && country) {
      fetchTopScoresData(treasureHunter, country)
    }
  }, [country, treasureHunter])

  const columns = [
    {
      title: 'Rank',
      dataIndex: 'rank',
      key: 'rank',
    },
    {
      title: 'User Name',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Points',
      dataIndex: 'points',
      key: 'points',
    },
    {
      title: 'Rewards',
      dataIndex: 'rewards',
      key: 'rewards',
      render: (rewards: any) => {
        if (!rewards) return '-'
        return (
          <Space size="middle" wrap>
            {Object.entries(rewards as Record<string, number>)
              .sort(
                ([a], [b]) => rewardOrder.indexOf(a) - rewardOrder.indexOf(b)
              )
              .map(([rewardName, rewardCount]) => (
                <div
                  key={rewardName}
                  style={{
                    padding: '2px 6px',
                    border: '1px solid #f0f0f0',
                    borderRadius: '8px',

                    fontSize: '14px',
                    fontWeight: 500,
                  }}
                >
                  {rewardName}: {rewardCount}
                </div>
              ))}
          </Space>
        )
      },
    },
  ]

  return (
    <>
      <Spin spinning={loading}>
        <Select
          placeholder="Select Treasure Hunter"
          value={treasureHunter}
          onChange={handleTreasureHunterChange}
          options={treasureHunters}
          style={{ width: '12%', marginLeft: '10px' }}
        />
        <Select
          placeholder="Select Country"
          value={country}
          onChange={handleCountryChange}
          options={countries}
          style={{ width: '12%', marginLeft: '10px' }}
        />
        <Divider />
        <DndProvider backend={HTML5Backend}>
          <Table
            dataSource={transformedData}
            columns={columns}
            pagination={false}
          />
        </DndProvider>
      </Spin>
    </>
  )
}

export default TreasureHunterLeaderBoard
